<template>
  <li class="talent-filter-item">
    <div class="talent-filter-item__content">
      <div class="talent-filter-item__image">
        <img :src="talent.profile_image_url">
      </div>
<!--      <div class="talent-filter-item__copy">-->
<!--        <div class="">-->
<!--          <router-link tag="a" :to="{ name: 'talent.profile.view', params: { id: talent.id, status: 'event' }}" target="_blank" style="text-decoration: underline">-->
<!--            <span>{{ talent.name }}</span>-->
<!--            <i v-if="talent.management && !$userIsManager" class="fa fa-fw fa-group" :aria-label="talent.management.company" :title="talent.management.company"/>-->
<!--            <i v-if="talent.profile.visibility === 'hidden' && ($userIsAdmin || $userIsManager)" class="fa fa-eye-slash" aria-label="hidden" title="hidden"/>-->
<!--            <i v-if="talent.profile.visibility === 'private' && ($userIsAdmin || $userIsManager)" class="fa fa-lock" aria-label="private" title="private"/>-->
<!--          </router-link>-->
<!--          <div class="tagline" :title="talent.profile.tagline" v-if="talent.profile.tagline" >{{ talent.profile.tagline }}</div>-->
<!--          <div class="talent-filter-item__details" >-->
<!--            <p v-if="canSeeEarnings" style="color: #5cb85c"> {{ engagements }} <i class="fa fa-fw fa-briefcase"></i> &nbsp; &nbsp; {{ earnings }} <i class="fa fa-fw fa-money"></i></p>-->
<!--            <div class="talent-filter-item__contract" v-if="$talentContractsModuleEnabled">-->
<!--              <div v-if="talent.contracts && talent.contracts.length">-->
<!--                <span v-for="requirement in talent.contracts[0].user_requirement_values" :key="requirement.id">-->
<!--                  {{ requirement.name }}: {{ requirement.value }}{{ requirement.requirement_value ? '/' + requirement.requirement_value : ''}}<br/>-->
<!--                </span>-->
<!--                <strong :title="talent.contracts[0].name" class="contract-name">{{talent.contracts[0].name}} </strong>-->
<!--              </div>-->
<!--              <div v-else>-->
<!--                <br /><br />-->
<!--              </div>-->
<!--            </div>-->
<!--            <div v-else-if="talent.profile.highest_followers || talent.talent_bookings_count || talent.total_engagements" class="flex" style="justify-content: space-between">-->
<!--              <div v-if="!$hideSocialMediaReferences && talent.profile.highest_followers && talent.total_earnings === undefined" title="Highest followers"><i :class="'fab ' + talent.profile.highest_followers_icon"></i> {{ talent.profile.highest_followers }}</div>-->
<!--              <div v-if="talent.total_engagements !== undefined" title="Booking count"><i class="fa fa-briefcase"></i> {{ talent.total_engagements | nullable }}</div>-->
<!--              <div v-else-if="talent.talent_bookings_count" title="Booking count"><i class="fa fa-briefcase"></i> {{ talent.talent_bookings_count }}</div>-->
<!--              <div v-if="talent.total_earnings !== undefined" :title="talent.currency === 'points' ? 'Total points' : 'Total earnings'">-->
<!--                <i v-if="talent.currency && talent.currency !== 'points'" class="fa fa-dollar"></i>-->
<!--                <i v-else class="fa fa-check"></i>-->
<!--                {{ talent.total_earnings | nullable }}-->
<!--              </div>-->
<!--            </div>-->
<!--            <div v-if="talent.total_completed_booking_time" title="Total time"><i class="fa fa-clock-o"></i> {{ talent.total_completed_booking_time }}</div>-->
<!--            <div v-if="talent.talent_key_metrics" v-for="metrics in talent.talent_key_metrics" :key="metrics.attribute">-->
<!--              <div v-if="metrics.value" :title="metrics.title">-->
<!--                <i class="fa" v-bind:class="metrics.icon"></i> {{metrics.value}}-->
<!--              </div>-->
<!--            </div>-->
<!--            <div v-if="$retired">{{ $t(talent.profile.retired) | sentenceCase }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="talent-filter-item__copy">
        <div class="">
          <router-link tag="a" :to="{ name: 'talent.profile.view', params: { id: talent.id, status: 'event' }}" target="_blank" style="text-decoration: underline">
            <span>{{ talent.name }}</span>
            <i v-if="talent.management && !$userIsManager" class="fa fa-fw fa-group" :aria-label="talent.management.company" :title="talent.management.company"/>
            <i v-if="talent.profile.visibility === 'hidden' && ($userIsAdmin || $userIsManager)" class="fa fa-eye-slash" aria-label="hidden" title="hidden"/>
            <i v-if="talent.profile.visibility === 'private' && ($userIsAdmin || $userIsManager)" class="fa fa-lock" aria-label="private" title="private"/>
          </router-link>
          <div v-if="$showTalentStatsForClient || $talentContractsModuleEnabled || $userIsAdmin"> <!--restricts client access  if showTalentStatsForClient is false-->
            <div class="tagline" :title="talent.profile.tagline" v-if="talent.profile.tagline" >{{ talent.profile.tagline }}</div>
            <div class="talent-filter-item__details" >
              <p v-if="canSeeEarnings" style="color: #5cb85c"> {{ engagements }} <i class="fa fa-fw fa-briefcase"></i> &nbsp; &nbsp; {{ earnings }} <i class="fa fa-fw fa-money"></i></p>
              <div class="talent-filter-item__contract" v-if="$talentContractsModuleEnabled"><!--shows to client when talent stats for client is true even if talentContractsModuleEnabled is false-->
                <div v-if="talent.contracts && talent.contracts.length">
                  <span v-for="requirement in talent.contracts[0].user_requirement_values" :key="requirement.id">
                    {{ requirement.name }}: {{ requirement.value }}{{ requirement.requirement_value ? '/' + requirement.requirement_value : ''}}<br/>
                  </span>
                  <strong :title="talent.contracts[0].name" class="contract-name">{{talent.contracts[0].name}} </strong>
                </div>
                <!-- <div v-else>
                  <br /><br />
                </div> -->
              </div>
              <div v-else>
                <div class="flex" style="justify-content: space-between">
                  <div v-if="!$hideSocialMediaReferences && talent.profile.highest_followers && talent.total_earnings === undefined" title="Highest followers"><i :class="'fab ' + talent.profile.highest_followers_icon"></i> {{ talent.profile.highest_followers }}</div>
                  <div v-if="$vlastMode && talent.total_engagements !== undefined" title="Booking count"><i class="fa fa-briefcase"></i> {{ talent.total_engagements | nullable }} </div>
                  <div v-else-if="$vlastMode && talent.talent_bookings_count !== undefined" title="Booking count"><i class="fa fa-briefcase"></i> {{ talent.talent_bookings_count > 0 ? talent.talent_bookings_count : '-'}} </div>
                  <div v-if="talent.total_earnings !== undefined" :title="talent.currency === 'points' ? 'Total points' : 'Total earnings'">
                    <i v-if="talent.currency && talent.currency !== 'points'" class="fa fa-dollar"></i>
                    <i v-else class="fa fa-check"></i> {{ talent.total_earnings | nullable }}
                  </div>
                </div>
                <div v-if="talent.total_completed_booking_time" title="Total time"><i class="fa fa-clock-o"></i> {{ talent.total_completed_booking_time }}</div>
              </div>
              <div v-if="talent.talent_key_metrics" v-for="metrics in talent.talent_key_metrics" :key="metrics.attribute">
                <div v-if="metrics.value" :title="metrics.title">
                  <i class="fa" v-bind:class="metrics.icon"></i> {{metrics.value}}
                </div>
              </div>
            </div>
          </div>
          <div v-if="$retired">{{ $t(talent.profile.retired) | sentenceCase }}</div>
        </div>
      </div>
    </div>
    <div class="talent-filter-item__cta">
      <input v-model="budget" v-if="canSetBudgetPerTalent && talentIsAlreadyAdded && bookingBudget"/>
      <a v-if="talentIsAlreadyAdded" @click="handleRemoveTalentCallback(talent)" class="btn btn-sm btn-success">
        <i class="fa fa-fw fa-check"></i>
      </a>
      <a v-else @click="handleAddTalentCallback(talent)" class="btn btn-sm btn-default" :disabled="hasLimit && selectedStars.length >= 10">
        <i class="fa fa-fw fa-plus"></i>
      </a>
    </div>
  </li>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { find } from 'lodash'

export default {
  props: {
    talent: {
      required: true
    },
    bookingBudget: {
      required: false,
      default: 0
    },
    hasLimit: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      budget: this.bookingBudget
    }
  },

  computed: {
    ...mapState('filtering', ['stars', 'selectedStars']),
    ...mapState('shortlist', ['shortlist']),

    talentIsAlreadyAdded () {
      return find(this.selectedStars, added => added.id === this.talent.id) !== undefined
    },

    canSeeEarnings () {
      return this.$userIsAdmin && (this.engagements > 0 || this.earnings > 0) && ['Pickstar', 'NRL'].includes(this.clientName)
    },

    canSetBudgetPerTalent () {
      return this.$userIsAdmin
    },

    engagements () {
      return this.talent.talent_stats && this.talent.talent_stats.total_engagements && this.talent.talent_stats.total_engagements.metric ? this.talent.talent_stats.total_engagements.metric : 0
    },

    earnings () {
      return this.talent.talent_stats && this.talent.talent_stats.total_earnings && this.talent.talent_stats.total_earnings.metric ? this.talent.talent_stats.total_earnings.metric : 0
    }
  },

  watch: {
    budget () {
      if (this.$userIsAdmin) {
        this.updateSelectedStarsBudget({ userId: this.talent.id, budget: parseInt(this.budget) })
      }
    }
  },

  methods: {
    ...mapActions('filtering', ['addSelectedStars', 'removeSelectedStar', 'updateSelectedStarsBudget']),

    /**
       * Handle adding talent to the array of additional talent.
       *
       * @return void
       */
    handleAddTalentCallback (talent) {
      talent.budget = this.budget
      if (this.hasLimit && this.shortlist.length >= 10) {
        return
      }
      this.addSelectedStars(talent)
    },

    /**
       * Handle removing talent from the array of additional talent.
       *
       * @return void
       */
    handleRemoveTalentCallback (talent) {
      this.removeSelectedStar(talent.id)
    },

    showToClient () {
      return (this.$talentContractsModuleEnabled || this.$showTalentStatsForClient) && (this.$userIsAdmin === false && this.$userIsManager === false)
    },

    showToAdminManager () {
      return (this.$talentContractsModuleEnabled) && (this.$userIsAdmin || this.$userIsManager)
    }
  }
}
</script>

<style lang="scss">
  @import 'src/assets/sass/mixins/global-mixins';
  .talent-filter-item {
    display: flex;
    flex-flow: row nowrap;
    padding: 5px;
    @media (max-width: 639px) {
      width: 100%;
    }
    @media (min-width: 640px) and (max-width: 1279px) {
      width: 50%;
      @include when-in-modal {
        width: 50%;
      }
    }
    @media (min-width: 1280px) {
      width: 50%;
      @include when-in-modal {
        width: calc(100% / 3);
      }
    }
    &__content {
      display: flex;
      width: 80%;
      padding-right: 1rem;
    }
    &__image {
      width: 3rem;
      flex-shrink: 0;
      margin-right: 1rem;
    }
    &__copy {
      width: 70%;
    }
    &__details {
      margin-top: 7px;
    }
    &__contract {
      margin-top:0;
      font-size: 0.9em;
      line-height: 1;
    }
  }
  .contract-name {
    display:block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .tagline {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
